/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Client_NextInputs */

const en_features_client_next = /** @type {(inputs: Features_Client_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next visit`)
};

const pl_features_client_next = /** @type {(inputs: Features_Client_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następna wizyta`)
};

/**
* | output |
* | --- |
* | "Next visit" |
*
* @param {Features_Client_NextInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_client_next = /** @type {((inputs?: Features_Client_NextInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Client_NextInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_client_next(inputs)
	return en_features_client_next(inputs)
});